// 字典常量
export const LEASE_STATUS_DICT = [
  { label: '待生效', value: 1 },
  { label: '生效中', value: 2 },
  { label: '即将到期', value: 3 },
  { label: '已到期', value: 4 },
  { label: '已终止', value: 5 },
  { label: '已退租', value: 6 },
]

export const YES_NO_DICT = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
]

export const changeTypeOptions =  [
  { label: '续签', value: 1 },
  { label: '提前终止', value: 2 },
  { label: '面积调整', value: 3 },
  { label: '货主变更', value: 4 },
  { label: '租期延长', value: 5 },
  { label: '租期缩短', value: 6 }
]
